<div class="tm-modal-footer" mat-dialog-actions align="end">
  <ng-content #customTemp></ng-content>
  <ng-container *ngIf="!footerTemp">
    <button *ngIf="modal.cancelBtnLabel" type="button" mat-stroked-button (click)="modal.close(modal.CLOSE_REASON.CLOSE)">{{ modal.cancelBtnLabel }}</button>
    <button *ngIf="modal.okBtnLabel" type="button" mat-stroked-button (click)="modal.close(modal.CLOSE_REASON.SUBMIT)" cdkFocusInitial>{{ modal.okBtnLabel }}</button>
  </ng-container>
</div>
